export function reminderConfirmationEndpoint(projectUrl:unknown):string {
 if(typeof projectUrl!=='string'||projectUrl!==projectUrl.trim()||!/^https:\/\/[a-z0-9]+\.supabase\.co$/.test(projectUrl))throw Error('confirmation_not_configured');
 return projectUrl+'/functions/v1/admin-v2-confirm-reminder';
}
